import type {
  PointsAttentionPrecis,
  ResumesPointsAttention,
} from '../../../../../back/src/metier/nis2-simulateur/Regulation.definitions';

export const TextesDesResumes: Record<ResumesPointsAttention, string> = {
  NumeriqueUE: `
    En raison de certaines de vos activités liées aux infrastructures
    numériques, de gestion des services TIC ou de fourniture de services
    numériques, nous vous invitons à vous rapprocher de l'autorité
    nationale compétente NIS&nbsp;2 de l'État membre de l'UE dans
    lequel se trouve votre établissement principal.
  `,
  EtabliUE: `
    Nous vous invitons à vous rapprocher de l'autorité nationale
    compétente NIS&nbsp;2 de l'État membre de l'UE dans lequel vous
    êtes établi.
  `,
  RepresentantUE: `
    Nous vous invitons à vous rapprocher de l'autorité nationale
    compétente NIS&nbsp;2 de l'État membre de l'UE dans lequel votre
    représentant est ou sera établi.
  `,
};

export const Precisions: Record<PointsAttentionPrecis, { titre: string; texte: string }> = {
  MecanismeExemptionSecuriteNationale: {
    titre: 'Sécurité nationale',
    texte: `
      Des mécanismes d'exemption pourront être mis en place au cas par
      cas par le gouvernement français pour certaines entités répondant à des
      critères spécifiques.
      <br />
      En effet, les entités qui exercent des activités dans les domaines de la
      sécurité nationale, de la sécurité publique, de la défense ou de
      l'application de la loi, y compris la prévention et la détection
      des infractions pénales, ainsi que les enquêtes et les poursuites en la
      matière, ou qui fournissent des services exclusivement aux entités de
      l'administration publique exerçant des activités dans les domaines
      susmentionnés peuvent être exemptées de certaines obligations relatives
      à la directive NIS&nbsp;2 lorsqu'elles n'agissent pas en tant
      que prestataire de services de confiance.
      <br />
      Ces éventuelles exemptions seront connues à l'issue du processus de
      transposition de la directive NIS&nbsp;2.
    `,
  },
  TelecomFranceEtAutresEMdelUE: {
    titre: 'Juridiction',
    texte: `
      Au titre de votre activité de fournisseur de réseaux de communications
      électroniques publics et/ou de fournisseur de services de communications
      électroniques accessibles au public, votre entité relève, pour lesdites
      activités, de l'ensemble des Etats membres de l'Union
      Européenne (dont la France) dans lesquels vos services sont fournis et
      devra se conformer aux réglementations NIS&nbsp;2 en vigueur dans ces
      Etats membres-ci.
    `,
  },
  TelecomAutresEMdelUEUniquement: {
    titre: 'Juridiction',
    texte: `
      Au titre de votre activité de fournisseur de réseaux de communications
      électroniques publics et/ou de fournisseur de services de communications
      électroniques accessibles au public, votre entité relève, pour lesdites
      activités, de l'ensemble des Etats membres de l'Union
      Européenne dans lesquels vos services sont fournis et devra se conformer
      aux réglementations NIS 2 en vigueur dans ces Etats membres-ci.
    `,
  },
  ResilienceEntiteCritique: {
    titre: 'Directive REC',
    texte: `
      Toute entité régulée par
      <a
        href="https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32022L2557"
        target="_blank"
        rel="noreferrer"
      >
        la directive (UE) 2022/2557
      </a>
      concernant la Résilience des Entités Critiques (REC) sera également
      soumise à NIS&nbsp;2, en tant qu'entité essentielle.
    `,
  },
  NumeriqueEtabliEMUEhorsFrance: {
    titre: 'Juridiction',
    texte: `
      Votre entité exerce des activités des secteurs «&nbsp;Infrastructure
      numérique&nbsp;», «&nbsp;Gestion des services TIC&nbsp;» et/ou
      «&nbsp;Fournisseurs numériques&nbsp;» pour lesquelles
      l'établissement principal au sens de la directive NIS&nbsp;2 est
      dans l'Union Européenne, hors de France. Pour ces activités-ci,
      votre entité dépend de l'Etat membre de l'Union Européenne
      dans lequel se trouve votre établissement principal, et, à ce titre,
      nous vous invitons à vous rapprocher de l'autorité nationale
      compétente NIS&nbsp;2 associée.
    `,
  },
  DORA: {
    titre: 'Règlement DORA',
    texte: `
      Certaines entités exerçant dans le secteur financier (secteur bancaire,
      infrastructure des marchés financiers, assurances désignées opérateurs
      de services essentiels en France au titre de NIS&nbsp;1…) seront
      également concernées par
      <a
        href="https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32022R2554"
        target="_blank"
        rel="noreferrer"
      >
        le règlement (UE) DORA 2022/2554
      </a>
      pour la Résilience Opérationnelle Numérique, qui sera applicable en
      l'état dans tous les pays de l'Union Européenne à partir du 17
      janvier 2025.
      <br />
      Pour ces entités, les obligations de la directive DORA en matière de
      gestion de risques, de notification d'incidents et de supervision
      se substitueront aux obligations de même type de la directive
      NIS&nbsp;2. En revanche, les autres obligations de la directive
      NIS&nbsp;2 (telles celle au registre des entités essentielles et
      importantes) demeureront pour les entités susmentionnées.
    `,
  },
  EnregistrementNomsDeDomaine: {
    titre: "Fournisseur de services d'enregistrement de noms de domaine",
    texte: `
      Votre entité exerce l'activité de fournisseur de services
      d'enregistrement de noms de domaine. Si votre entité n'exerce
      aucune autre activité régulée par la directive NIS&nbsp;2 alors, dans ce
      cas, vos seules obligations concerneront l'enregistrement de votre
      entité auprès de l'autorité nationale désignée (ainsi que la mise à
      jour des données enregistrées en cas de changement).
    `,
  },
  CriteresDePossibleInclusion: {
    titre: 'Critères de désignation unitaire « Entité Essentielle » ou « Entité Importante »',
    texte: `
      Sur la base de critères exposés ci-après, des désignations unitaires
      peuvent être décidées par le gouvernement français, au cas par cas :
      <ul>
        <li>
          une entité a priori non incluse par défaut dans le périmètre des
          entités régulées NIS&nbsp;2 peut être désignée entité essentielle ou
          entité importante&nbsp;;
        </li>
        <li>
          une entité a priori importante par défaut peut être désignée entité
          essentielle.
        </li>
      </ul>
      Les critères de désignation unitaire sont les suivants :
      <ul>
        <li>
          l'entité est, dans un État membre, le seul prestataire
          d'un service qui est essentiel au maintien d'activités
          sociétales ou économiques critiques&nbsp;;
        </li>
        <li>
          une perturbation du service fourni par l'entité pourrait avoir
          un impact important sur la sécurité publique, la sûreté publique ou
          la santé publique&nbsp;;
        </li>
        <li>
          une perturbation du service fourni par l'entité pourrait
          induire un risque systémique important, en particulier pour les
          secteurs où cette perturbation pourrait avoir un impact
          transfrontière&nbsp;;
        </li>
        <li>
          l'entité est critique en raison de son importance spécifique au
          niveau national ou régional pour le secteur ou le type de service en
          question, ou pour d'autres secteurs interdépendants dans
          l'État membre.
        </li>
      </ul>
    `,
  },
  OSE: {
    titre: 'Opérateur de Service Essentiel',
    texte: `
      Dans le cas où votre entité a été désignée Opérateur de Service
      Essentiel au titre de NIS&nbsp;1
      <a
        href="https://eur-lex.europa.eu/legal-content/FR/TXT/?uri=CELEX:32016L1148"
        target="_blank"
        rel="noreferrer"
      >
        (Directive (UE) 2016/1148)
      </a>
      , celle-ci sera désignée entité essentielle au titre de la
      réglementation NIS&nbsp;2.
    `,
  },
};
